// extracted by mini-css-extract-plugin
export default {"back-to-list":"BackToListButton_back-to-list__WBNwB","back-to-list-icon":"BackToListButton_back-to-list-icon__u8Tiu","back-to-list-link":"BackToListButton_back-to-list-link__XSsG5"};